import type Client from '../client'
import type {
  DownloadResponse,
  ErrorAble
} from '@/api'

export default class Invoice {
  constructor(private client: Client) {}

  download(invoice_id: number): Promise<ErrorAble<DownloadResponse>> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await this.client.post(`invoice/${invoice_id}/download`))
      } catch (error) {
        reject(error)
      }
    })
  }
}
